// ExternalUserInput.js
import React, { useState } from 'react';
const ExternalUserInput = ({ selectedUsers, handleSelectUser, handleRemoveUser }) => {
    const [userInput, setUserInput] = useState('');
  
    const handleAddUser = (e) => {
      e.preventDefault();
      const trimmedInput = userInput.trim();
      if (trimmedInput && !trimmedInput.includes(' ')) {
        handleSelectUser(trimmedInput); // Pass the name to the parent to handle it
        setUserInput('');
      }
    };
  
    return (
      <div>
        <div className="form-group row">
          <label htmlFor="userInput" className="form-label col-md-12">
            Enter External Professor Name
          </label>
          <div className="col-md-7">
            <input
              type="text"
              id="userInput"
              className="form-control"
              placeholder="Enter external professor name"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
            />
          </div>
          <div className="col-md-3" style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <button
              className="btn btn-primary"
              style={{ marginTop: '10px' }}
              onClick={handleAddUser}
            >
              Add
            </button>
          </div>
        </div>
  
        <div style={{ marginTop: '20px' }}>
          <h4>External author(s)</h4>
          <ul>
            {selectedUsers.map((user, index) => (
              <li key={index} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span>{user}</span>
                <button
                  style={{
                    color: 'red',
                    cursor: 'pointer',
                    padding: '5px 10px',
                    border: '1px solid red',
                    backgroundColor: 'transparent',
                    borderRadius: '5px',
                    marginLeft: '10px',
                  }}
                  onClick={() => handleRemoveUser(user)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };
  

export default ExternalUserInput;
